import { normalizeText } from './conversation-utils';

type AssistantActivityLifecycle = {
  phase?: string | null;
  status?: string | null;
};

export function isCancelledAssistantActivityStatus(status?: string | null) {
  const normalized = normalizeText(status)?.toLowerCase();
  return normalized === 'cancelled' || normalized === 'canceled';
}

export function isTerminalFailureAssistantActivityStatus(
  status?: string | null
) {
  const normalized = normalizeText(status)?.toLowerCase();
  return normalized === 'failed' || normalized === 'error';
}

export function isSettledAssistantActivityStatus(status?: string | null) {
  const normalized = normalizeText(status)?.toLowerCase();
  return (
    normalized === 'cancelled' ||
    normalized === 'canceled' ||
    normalized === 'completed' ||
    normalized === 'done' ||
    normalized === 'success' ||
    normalized === 'paused'
  );
}

export function shouldRetainAssistantActivityForSurface(
  activity: AssistantActivityLifecycle | null | undefined
) {
  if (!activity) return false;
  const status = normalizeText(activity.status)?.toLowerCase();
  if (isTerminalFailureAssistantActivityStatus(status)) {
    return true;
  }
  if (isSettledAssistantActivityStatus(status)) {
    return false;
  }
  return normalizeText(activity.phase)?.toLowerCase() !== 'idle';
}

export function isActiveAssistantActivityForSurface(
  activity: AssistantActivityLifecycle | null | undefined
) {
  if (!shouldRetainAssistantActivityForSurface(activity)) {
    return false;
  }
  return !isTerminalFailureAssistantActivityStatus(activity?.status);
}
